const login = {
  password: 'Clave',
  login: 'Acceso',
  sign_in: 'Iniciar sesión',
  click_msg: 'Al hacer clic en Iniciar sesión, aceptas nuestros',
  terms: 'Términos y condiciones',
  and: 'y',
  privacy: 'Política de privacidad',
  account_msg: '¿No tienes cuenta?',
  register_here: 'Registrarse aquí',
  sign_in_error:
    'Ocurrió un error. Por favor, intente iniciar sesión de nuevo...',
  cloud_based_title: 'Sistema de control de acceso en la nube',
};

export default login;
